import React from 'react';
import { IonModal, IonButton, IonItem, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel  } from '@ionic/react';
import { IonSlides, IonSlide, IonGrid, IonRow, IonCol, IonImg } from '@ionic/react';


export class HomeButton extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <IonButton class="homeToolbarButtons" routerLink='/home'> Home </IonButton>
        )
    }
}

export class Menu extends React.Component {
    constructor(props) {
        super(props);

        /*this.state = {
            acctID: this.props.accountID,
            schema: this.props.schemaName
        };*/
    }


    render() {

        return (
            <IonMenu contentId='qavaAppConfirmed' disabled={this.props.disabled} side='end'>
                <IonHeader>
                    <IonToolbar> 
                        <IonTitle>
                            Menu
                        </IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <IonList>
                        <IonMenuToggle auto-hide='false'>
                            {/*<Link to='/merchantMainPageApp'>Home</Link>*/}
                            <IonItem button routerLink='/merchantMainPageApp'>
                                <IonLabel>Home</IonLabel>
                            </IonItem>
                        </IonMenuToggle>
                        <IonMenuToggle auto-hide='false'>
                            <IonItem button routerLink='/profileSetting'>
                                <IonLabel>Profile</IonLabel>
                            </IonItem>
                        </IonMenuToggle>
                        <IonMenuToggle auto-hide='false'>
                            <IonItem button routerLink='/accountSetting'>
                                <IonLabel>Account</IonLabel>
                            </IonItem>
                        </IonMenuToggle>
                        <IonMenuToggle auto-hide='false'>
                            <IonItem button routerLink='/logout'>
                                <IonLabel>Logout</IonLabel>
                            </IonItem>
                        </IonMenuToggle>
                    </IonList>                
                </IonContent>
            </IonMenu>
        )
    }
}

//let items = [];


export class UploadedInvoiceTemplates extends React.Component   {
//export const UploadedInvoiceTemplates: React.FC = (props: any) => {


    constructor(props) {
        super(props);
        //this.uploadedInvoices = this.uploadedInvoices.bind(this);


        this.getData = this.getData.bind(this);
        //let items = [];

        this.state = {
            acctID: this.props.accountID,
            schema: this.props.schemaName,
            items: [],
            downloadComplete: false
            //showInvoiceTemplates: false

        }
    }

    //uploadedInvoices() {
    async getData() {
            
            const requestOptions = {
                method: 'POST',
                credentials: 'include',
                headers: {'content-type': 'application/json' },
                body: JSON.stringify({
                    Tracker: 72004,
                    user: this.state.acctID

                }),
            }
            
            await fetch('https://ghanaverified.com/api', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    this.setState(() => {
                            
                            let items = this.state.items.concat({
                            imageID: cols[0],
                            originalImage: cols[1],
                            postscriptImage: cols[2],
                            imgHeight: Math.floor(Math.random() * 50 + 150)
                            });
                            
                            return {
                                items,
                                value: {
                                    imageID: cols[0],
                                    originalImage: cols[1],
                                    postscriptImage: cols[2],
                                    imgHeight: Math.floor(Math.random() * 50 + 150)
                                    },
                            };
                    })

                } 
            })
            
            this.setState(() => ({
                downloadComplete: true,
                
            }));
    }

    /*updateShowInvoiceTemplates(event) {

        this.setState(() => ({
            showInvoiceTemplates: event
        }));
    }*/

    componentWillMount() {

        //alert('In UploadedInvoiceTemplates');
        //alert(this.state.acctID);


        this.getData();  
    }

    render() {

        let condition = this.state.downloadComplete;

        if(condition)
        {
            return (


                /*<IonInfiniteScroll items='items' threshold='100px'>
                <IonInfiniteScrollContent>*/
                //<IonModal id='showInvoiceTemplates' isOpen={ this.state.showInvoiceTemplates }>
                    <IonContent id='invoiceTemplatesModal'>
                        <IonSlides>
                            {this.state.items.map((item) =>   {
                                    return (
                                        <IonSlide key={item.imageID}>
                                            <IonGrid  class='BusinessTabSlideGrid'>
                                            <IonRow>
                                                <IonCol>
                                                    <h1>{item.imageID}</h1>
                                                    {/*<h1>{this.state.items[0].imageID}</h1>*/}
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol>
                                                        <IonImg src={item.originalImage}></IonImg>
                                                        {/*<IonImg src={this.state.items[0].originalImage}></IonImg>*/}
                                                </IonCol>
                                                <IonCol>
                                                        <IonImg src={item.postscriptImage}> </IonImg>
                                                        {/*<IonImg src='assets/merchants/image-not-available.jpg'> </IonImg>*/}
                                                        {/*<IonImg src='https://ghanaverified.com/../../../../../../web/Public/fileServer/merchants/image-not-available.jpg'></IonImg>*/}
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol>
                                                    <IonButton>Request Form</IonButton>
                                                </IonCol>
                                                <IonCol>
                                                    <IonButton>Actons</IonButton>
                                                </IonCol>
                                            </IonRow>
                                            </IonGrid>
                                        </IonSlide>
                                    );
                                }
                            )}
                        </IonSlides>
                    </IonContent>
                    //<IonButton onClick={() => this.updateShowInvoiceTemplates(false)}>
                     //           Close Modal
                    //</IonButton>
                //</IonModal>

                
            )
        }
       else
       {
           return (


            /*<IonInfiniteScroll items='items' threshold='100px'>
            <IonInfiniteScrollContent>*/
            //<IonModal id='showInvoiceTemplates' isOpen={ this.state.showInvoiceTemplates }>
                //<IonContent id='invoiceTemplatesModal'>
                    //<IonSlides>
                        //{this.items.map((item) =>   {
                           // return (
                                //<IonSlide /*key={item.imageID}*/>
                                    <IonGrid  class='BusinessTabSlideGrid'>
                                    <IonRow>
                                        <IonCol>
                                            <h1>{'No Images'}</h1>
                                            {/*<h1>{this.items[0].imageID}</h1>*/}
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                                {/*<IonImg src={item.originalImage}></IonImg>*/}
                                               {/* <IonImg src={this.items[0].originalImage}></IonImg>*/}
                                        </IonCol>
                                        <IonCol>
                                                {/*<IonImg src={item.postscriptImage}> </IonImg>*/}
                                                {/*<IonImg src='assets/merchants/image-not-available.jpg'> </IonImg>*/}
                                                {/*<IonImg src='https://ghanaverified.com/../../../../../../web/Public/fileServer/merchants/image-not-available.jpg'></IonImg>*/}
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonButton>Request Form</IonButton>
                                        </IonCol>
                                        <IonCol>
                                            <IonButton>Actons</IonButton>
                                        </IonCol>
                                    </IonRow>
                                    </IonGrid>
                                //</IonSlide>
                           // );
                       // }
                    //)}
                    //</IonSlides>
                //</IonContent>
                //<IonButton onClick={() => this.updateShowInvoiceTemplates(false)}>
                 //           Close Modal
                //</IonButton>
            //</IonModal>

            
        )    
    }

    }   
}